module.exports = __webpack_public_path__ + "img/case-logo-16.335af90e.png";